export default function initFloatingButton(el: string) {
    const button = document.querySelector(el);
    if (!button) return;

    let buttonOffsetTop = button.getBoundingClientRect().top + window.scrollY;

    if (button.classList.contains('package-button')) {
        if (button.parentElement) {
            buttonOffsetTop = button.parentElement.getBoundingClientRect().bottom + window.scrollY;
        }
    }
    let timeoutId: number | null = null;

    const onScroll = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        timeoutId = window.setTimeout(() => {
            if (window.scrollY > buttonOffsetTop) {
                button.classList.add('not-in-view');
            } else {
                button.classList.remove('not-in-view');
            }
        }, 10); // Adjust the delay as needed
    };

    window.addEventListener('scroll', onScroll);
}
